import { z } from 'zod/v3';

const selectedIssueSchema = z.object({
  number: z.number(),
  title: z.string(),
  url: z.string().optional(),
});

const operationSchema = z.object({
  op: z.enum(['create', 'update']),
  path: z.string(),
  content: z.string(),
  explanation: z.string(),
});

const interviewMessageSchema = z.object({
  role: z.enum(['user', 'assistant', 'system']),
  content: z.string(),
});

export const codeBuilderValueSchema = z.object({
  repoEntityRef: z.string().optional(),
  issues: z.array(selectedIssueSchema).optional(),
  requirementsSummary: z.string().optional(),
  draft: z
    .object({
      c4Diagram: z.string().optional(),
      classDiagram: z.string().optional(),
      sequenceDiagram: z.string().optional(),
      operations: z.array(operationSchema),
      warnings: z.array(z.string()),
      openQuestions: z.array(z.string()),
    })
    .optional(),
  transcript: z.array(interviewMessageSchema).optional(),
  reviewConfirmed: z.boolean().optional(),
  review: z
    .object({
      status: z.string(),
      files: z.string(),
      openQuestions: z.number(),
    })
    .optional(),
});

export const codeBuilderUiOptionsSchema = z.object({
  // Catalog kinds selectable as the target repo. Omit to allow every kind
  // (the picker groups options by kind).
  repoKinds: z.array(z.string()).optional(),
  height: z.number().optional(),
});
